import type { SortOrder } from '../table-header-cell/table-header-cell';

export const getNextSorting = (order?: SortOrder) => {
  if (order === 'asc') return 'desc';
  if (order === 'desc') return undefined;
  if (order === undefined) return 'asc';
};

export function sort<Type>(data: Type[], sortBy: keyof Type, order: SortOrder): Type[] {
  return data.sort((data1, data2) => {
    type ObjectKey = keyof typeof data1;

    let value1 = data1[sortBy as ObjectKey];
    let value2 = data2[sortBy as ObjectKey];

    if (typeof value1 === 'string') value1 = value1.toLowerCase() as Type[keyof Type];
    if (typeof value2 === 'string') value2 = value2.toLowerCase() as Type[keyof Type];

    if (order === 'asc') {
      return value1 > value2 ? 1 : -1;
    }

    return value1 > value2 ? -1 : 1;
  });
}
